<form
  id="survey-form"
  class="survey-form-style flex w-full h-full flex-col justify-center pt-8"
  aria-live="polite"
  [formGroup]="form"
  (ngSubmit)="submit($event)"
>
  <div
    class="flex flex-col px-8 lg:px-0 flex-1 self-stretch mb-24 w-full gap-dynamic-theme"
  >
    @if (surveyTitle) {
      <h1
        class="font-normal text-[2.5rem] title-dynamic-theme mb-6"
        [innerHTML]="surveyTitle | safeHtml"
      ></h1>
    }
    @if (showSkeleton) {
      <app-survey-skeleton></app-survey-skeleton>
    } @else {
      @for (question of questions; track question.id) {
        <div [attr.data-question-id]="question.id">
          @switch (question.type) {
            @case ("OPENANSWER") {
              <app-open-answer
                [control]="form.get(question.id)!"
                [question]="question"
                [isFirstQuestion]="$index === 0"
              ></app-open-answer>
            }
            @case ("MATRIX") {
              <app-matrix
                [matrixQuestion]="question"
                [form]="form"
                [isFirstQuestion]="$index === 0"
              ></app-matrix>
            }
            @case ("MULTI_MATRIX") {
              <app-multi-matrix
                [multiMatrixQuestion]="question"
                [form]="form"
                [isFirstQuestion]="$index === 0"
              ></app-multi-matrix>
            }
            @case ("SINGLE_CHOICE") {
              @if (question.presentation === "DROPDOWN") {
                <app-single-select-dropdown
                  [question]="question"
                  [control]="form.get(question.id)"
                  [otherControl]="form.get(question.id + '-OTHER')"
                  [isFirstQuestion]="$index === 0"
                ></app-single-select-dropdown>
              } @else if (question.presentation === "SENTIMENT") {
                <app-satisfaction-meter
                  [question]="question"
                  [control]="form.get(question.id)"
                  [isFirstQuestion]="$index === 0"
                ></app-satisfaction-meter>
              } @else if (question.presentation.startsWith("NPS")) {
                <app-nps
                  [question]="question"
                  [control]="form.get(question.id)"
                  [isFirstQuestion]="$index === 0"
                  [displayAsSlider]="$any(question.presentation) === 'NPS,SLIDER'"
                ></app-nps>
              } @else {
                <app-single-select
                  [question]="question"
                  [control]="form.get(question.id)"
                  [otherControl]="form.get(question.id + '-OTHER')"
                  [isFirstQuestion]="$index === 0"
                ></app-single-select>
              }
            }
            @case ("INFORMATION") {
              <app-information-text
                [question]="question"
                [isFirstQuestion]="$index === 0"
              ></app-information-text>
            }
            @case ("HIERARCHICAL") {
              <app-hierarchical
                [question]="question"
                [formGroup]="getFormGroup(question.id, form)"
                [isFirstQuestion]="$index === 0"
              ></app-hierarchical>
            }
            @case ("PRIORITY_DROPDOWN") {
              <app-priority-dropdown
                [question]="question"
                [form]="getFormGroup(question.id, form)"
                [isFirstQuestion]="$index === 0"
              >
              </app-priority-dropdown>
            }
            @case ("MULTIPLE_CHOICE") {
              <app-multi-select
                [question]="question"
                [formGroup]="getFormGroup(question.id, form)"
                [otherControl]="form.get(question.id + '-OTHER')"
                [isFirstQuestion]="$index === 0"
              >
              </app-multi-select>
            }
            @case ("CALENDAR") {
              <app-locale-date
                [question]="question"
                [control]="form.get(question.id)!"
                [isFirstQuestion]="$index === 0"
              ></app-locale-date>
            }
            @case ("PRIORITY_DRAGDROP") {
              @if (form.get(question.id)) {
                <app-priority-dragdrop
                  [question]="question"
                  [control]="form.get(question.id)!"
                  [isFirstQuestion]="$index === 0"
                >
                </app-priority-dragdrop>
              }
            }
            @case ("FILE_UPLOAD") {
              <app-file-upload
                [control]="form.get(question.id)!"
                [question]="question"
                [isFirstQuestion]="$index === 0"
              ></app-file-upload>
            }
          }
        </div>
      }
    }
  </div>
  @if (questions.length > 0) {
    @let lastQuestion = questions[questions.length - 1];
    @if (
      ["HIERARCHICAL", "PRIORITY_DROPDOWN"].includes(lastQuestion.type) ||
      (lastQuestion.type === "SINGLE_CHOICE" &&
        lastQuestion.presentation === "DROPDOWN") ||
      hasDropdownRow(lastQuestion) ||
      (lastQuestion.type === "MULTI_MATRIX" &&
        lastQuestion?.columns?.[1]?.rows?.[0]?.presentation === "DROPDOWN")
    ) {
      <div class="min-h-[12rem]"></div>
    } @else {
      <div class="min-h-[3rem]"></div>
    }
  }
</form>
